// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  cart: icon('ic_cart'),
  user: icon('ic_user'),
  booking: icon('ic_booking'),
  dashboard: icon('ic_dashboard'),
  invoice: icon('ic_invoice'),
  calendar: icon('ic_calendar'),
  file: icon('ic_file'),
  banking: icon('ic_banking'),
};

const navConfig = [
  {
    items: [
      // Mediator Items
      {
        title: 'Dashboard',
        path: PATH_DASHBOARD.mediatorDashboard,
        icon: ICONS.dashboard,
        roles: ['mediator'],
        type: 'mediator',
      },
      {
        title: 'Richieste',
        path: PATH_DASHBOARD.mediatorBookings,
        icon: ICONS.booking,
        roles: ['mediator'],
        type: 'mediator',
      },
      {
        title: 'Fatturazione',
        path: PATH_DASHBOARD.fatturazione,
        icon: ICONS.file,
        roles: ['mediator'],
        type: 'mediator',
      },
      {
        title: 'Traduzioni',
        path: PATH_DASHBOARD.translationOrders,
        icon: ICONS.banking,
        roles: ['mediator'],
        type: 'mediator',
      },
      {
        title: 'Fatture',
        path: PATH_DASHBOARD.invoice,
        icon: ICONS.invoice,
        roles: ['mediator'],
        type: 'mediator',
      },
    ],
  },
];

export default navConfig;
